import { render, staticRenderFns } from "./client-edit-form.html?vue&type=template&id=f07c59aa&scoped=true&"
import script from "./client-edit-form.js?vue&type=script&lang=js&"
export * from "./client-edit-form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07c59aa",
  null
  
)

export default component.exports